import {http} from '@/services/http'

interface Token {
	cdcToken: string
}

/**
 * Client-side function to retrieve user token from the API.
 * Makes a request to the getToken endpoint with the specified locale.
 *
 * @param locale - The locale string for the token request
 * @returns Promise<Token> - The token data from the API
 */
export const populateToken = async (locale: string): Promise<Token> => {
	const endpoint = `/api/getToken?locale=${locale}`
	const {data} = await http<Token>({url: endpoint})

	return data
}
